import { fancyboxSuccessMessage } from "../forms/forms.js";
import {Fancybox} from "@fancyapps/ui";

function ratingNews() {
    const ratingNewsForm = document.getElementById('rating-news__form');
    if(ratingNewsForm){
        ratingNewsForm.addEventListener('submit', handleFormSubmit)
    }
}

export default ratingNews;

function handleFormSubmit(event) {
    event.preventDefault()

    const rating = event.submitter.dataset.rating;
    const ratingInput = event.target.querySelector('input[name="rating_news"]');
    ratingInput.value = rating;

    const data = serializeForm(event.target)

    fetch('classes/ajax/rating/addRatingNews.php', {
        method: 'POST',
        body: data,
    }).then(function(response) {
        return response.text();
    }).then(function(json) {

        // оценка
        const {ratingValue, reviewCount} = JSON.parse(json);
        const count = document.querySelector('.rating-news__count-val');
        const word = document.querySelector('.rating-news__count-word');
        count.textContent = reviewCount;
        word.textContent = getNoun(reviewCount, 'оценка', 'оценки', 'оценок')

        // рейтинг
        const ratingNews = document.querySelector('.rating-news');
        const rating = Math.round(ratingValue / reviewCount);
        ratingNews.className = '';
        ratingNews.classList.add('rating-news', 'rating-news_star-' + rating);

        // запрет повторной отправки
        event.target.querySelectorAll('.stars__item').forEach(star => {
            star.setAttribute('disabled', 'disabled');
        })
        event.target.classList.add('stars_disabled');
        event.target.setAttribute('title', 'Вы уже оценили эту статью');

        // сообщение
        fancyboxSuccessMessage('Спасибо за оценку!');
        setTimeout(() => {
            Fancybox.close();
        }, 1000);
    });
}

function serializeForm(formNode) {
    return new FormData(formNode)
}

function getNoun(number, one, two, five) {
    let n = Math.abs(number);
    n %= 100;
    if (n >= 5 && n <= 20) {
        return five;
    }
    n %= 10;
    if (n === 1) {
        return one;
    }
    if (n >= 2 && n <= 4) {
        return two;
    }
    return five;
}

// function ratingIPCompare(){
//     fetch('classes/ajax/rating/ratingIPCompare.php', {
//         method: 'POST',
//         // body: data,
//     }).then(function(response) {
//         return response.text();
//     }).then(function(json) {
//         console.log(json);
//     });
// }
// ratingIPCompare();